import { useForm } from 'react-hook-form';
import { IntegrationSettingsEntry, IntegrationSettingsOptionToAddForm } from 'modules/integrationSettings/types';
import { InputField } from 'components/form';
import { Button, Grid2 } from '@mui/material';

interface Props {
  integrationSettingsEntry: IntegrationSettingsEntry;
  onAdd: (optionToAdd: IntegrationSettingsOptionToAddForm) => void;
}

export const OptionToAddForm = ({ integrationSettingsEntry, onAdd }: Props) => {
  const emptyOption = { displayName: '', value: '' };

  const { control, getValues, reset } = useForm<IntegrationSettingsOptionToAddForm>({
    defaultValues: emptyOption,
  });

  const handleAdd = () => {
    onAdd(getValues());
    reset(emptyOption);
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={6}>
        <InputField control={control} label="Display Name" name="displayName" />
      </Grid2>
      <Grid2 size={6}>
        <InputField control={control} label={integrationSettingsEntry.displayName} name="value" />
      </Grid2>
      <Grid2 size={12}>
        <Button variant="contained" size="small" fullWidth onClick={handleAdd}>
          Add
        </Button>
      </Grid2>
    </Grid2>
  );
};
